import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex items-center overflow-hidden text-xl sm:overflow-visible lg:text-4xl" }
const _hoisted_3 = { class: "whitespace-nowrap font-normal leading-snug" }
const _hoisted_4 = { class: "select w-0 flex-auto font-normal leading-snug lg:flex-min" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "layout-normal mt-10"
}
const _hoisted_7 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_object_teaser_component = _resolveComponent("object-teaser-component")!

  return (_ctx.computedSelectedOption)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t(`same_${_ctx.computedSelectedOption.gender.toLowerCase()}`)), 1),
          _cache[1] || (_cache[1] = _createTextVNode("  ", -1)),
          _createElementVNode("span", _hoisted_4, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOption) = $event)),
              class: "font-medium"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.filter((option) => !option.disabled), (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  class: "font-normal",
                  key: option.value,
                  value: option.value
                }, _toDisplayString(_ctx.t(option.value)), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedOption]
            ])
          ])
        ]),
        (_ctx.objects.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objects, (object) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: object.id,
                    class: "object-teaser-wrapper"
                  }, [
                    _createVNode(_component_object_teaser_component, { object: object }, null, 8, ["object"])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}